const credentials =
  process.env.MIX_SIMPLYRETS_API_KEY +
  ':' +
  process.env.MIX_SIMPLYRETS_API_SECRET;

export const search = (form) => {
  const url = `https://api.simplyrets.com/properties?status=active&type=residential&limit=200&sort=-listprice`;

  return new Promise((resolve, reject) => {
    window.axios
      .get(url, {
        params: {
          q: form.search,
        },
        crossDomain: true,
        timeout: 3000,
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          Authorization: 'Basic ' + btoa(credentials),
        },
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        if (error.response.status == 422) {
          reject(error.response.data.errors);
        }
        reject(error);
      });
  });
};
